"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _mobileDialog = _interopRequireDefault(require("./mobileDialog"));
var _styles = require("./styles");
var _styles2 = require("@mui/styles");
var _material = require("@mui/material");
const _excluded = ["classes", "isDialogOpen", "isHeaderHidden", "title", "children", "disableBackdropClick", "disableEscapeKeyDown", "contentClass", "onDialogClose", "showCloseButton"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const SnetDialog = _ref => {
  let {
      classes,
      isDialogOpen,
      isHeaderHidden,
      title,
      children,
      disableBackdropClick,
      disableEscapeKeyDown,
      contentClass,
      onDialogClose,
      showCloseButton = true
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const isMobile = window.screen.width <= 550; //px

  // eslint-disable-next-line no-unused-vars
  const handleDialogClose = (event, reason) => {
    if (disableBackdropClick && reason === "backdropClick") {
      return false;
    }
    if (disableEscapeKeyDown && reason === "escapeKeyDown") {
      return false;
    }
    onDialogClose === null || onDialogClose === void 0 || onDialogClose();
  };
  if (isMobile) {
    return /*#__PURE__*/_react.default.createElement(_mobileDialog.default, {
      isDialogOpen: isDialogOpen,
      onDialogClose: onDialogClose,
      title: title,
      children: children
    });
  }
  return /*#__PURE__*/_react.default.createElement(_material.Dialog, _extends({
    maxWidth: "xl",
    onClose: (event, reason) => handleDialogClose(event, reason),
    "aria-labelledby": "snet-dialog-title",
    open: isDialogOpen,
    PaperProps: props === null || props === void 0 ? void 0 : props.PaperProps
  }, props), !isHeaderHidden && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.dialogTitle
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.titleText
  }, title), showCloseButton && onDialogClose && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "close",
    onClick: onDialogClose,
    className: classes.iconButton
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null))), /*#__PURE__*/_react.default.createElement(_material.DialogContent, {
    dividers: true,
    className: "".concat(classes.dailogContent, ", ").concat(contentClass)
  }, children));
};
SnetDialog.propTypes = {
  isDialogOpen: _propTypes.default.bool.isRequired,
  isHeaderHidden: _propTypes.default.bool,
  onDialogClose: _propTypes.default.func,
  title: _propTypes.default.string,
  children: _propTypes.default.node,
  showCloseButton: _propTypes.default.bool,
  disableBackdropClick: _propTypes.default.bool,
  disableEscapeKeyDown: _propTypes.default.bool,
  contentClass: _propTypes.default.string,
  props: _propTypes.default.shape({
    PaperProps: _propTypes.default.object
  })
};
var _default = exports.default = (0, _styles2.withStyles)(_styles.useStyles)(SnetDialog);